const openAddToGroupDialog = ids => ({
  type: 'ADD_TO_GROUP_DIALOG:OPEN',
  ids
})
const closeAddToGroupDialog = () => ({
  type: 'ADD_TO_GROUP_DIALOG:CLOSE'
})

export { openAddToGroupDialog, closeAddToGroupDialog }
